import * as React from "react"
import { Box } from "@mui/material"
import {useMarketAnalyzerReportForm} from "../../../@hooks";
import { ActionButton } from "@components"


export default function CreateReportButton() {
    const { handleOpenForm, isLoadingDrawer } = useMarketAnalyzerReportForm()

    return <Box componet="span" data-tour="market-analyzer-create-report">
        <ActionButton
            isLoading={isLoadingDrawer}
            label="Create New Report"
            icon="pen-to-square"
            onClick={handleOpenForm}
        />
    </Box>
}